import axiosInstance from "@/api/axiosInstance";
import { ReorderHeroItemsRequest, ReorderResponse } from "../types";

/**
 * Reorder hero items
 * PATCH /api/admin/hero-items/reorder
 */
export async function reorderHeroItems(
  data: ReorderHeroItemsRequest,
): Promise<ReorderResponse> {
  const response = await axiosInstance.patch<ReorderResponse>(
    "/api/admin/hero-items/reorder",
    data,
  );
  return response.data;
}
